// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.padding {\n\tpadding: 10px;\n}\n.margin-left {\n\tmargin-left: 10px;\n}\n.error {\n\tcolor: red;\n\tfont-size: 10px;\n\tmargin-top: -10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
